import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import ChangeInsightsRespondentHeader from '../../components/change-insights/ChangeInsightsRespondentHeader.jsx';
import SurveyRespondentAnswersForm from '../../components/change-insights/SurveyRespondentAnswersForm.jsx';
import CompletionDate from '../../components/CompletionDate.jsx';
import Empty from '../../components/Empty.jsx';
import { loadingContent } from '../../components/EmptyStates.jsx';
import ChangeInsightRespondentAnswersHeader from '../../components/headers/PageHeaders/ChangeInsights/ChangeInsightRespondentAnswersHeader.jsx';
import SubHeader from '../../components/SubHeader.jsx';
import VerticalSeparator from '../../components/VerticalSeparator.jsx';
import {
  retrieveChangeInsightDetails,
  retrieveTemplatesFeedbackForm,
  selectChangeInsightSettings,
  selectRetrieveChangInsightsState,
  selectSurveyResponsesResults,
} from '../../modules/changeInsights.js';
import {
  retrieveInitiative,
  selectInitiative,
  selectRetrieveInitiativeState,
  selectSearchQuery,
} from '../../modules/initiatives.js';
import { selectProject } from '../../modules/projects.js';
import { formatedTemplate } from './utils/index.jsx';

const mapDispatchToProps = (dispatch, { initiativeId, initiativeType }) =>
  bindActionCreators(
    {
      retrieveInitiative: () =>
        retrieveInitiative(initiativeType, initiativeId),
      retrieveTemplatesFeedbackForm,
      retrieveChangeInsightDetails,
    },
    dispatch
  );

const mapStateToProps = (state, { projectId, initiativeId, initiativeType }) =>
  createSelector(
    selectInitiative(initiativeId, initiativeType),
    selectSearchQuery,
    (initiative) => {
      const retrieveSuccess = [
        selectRetrieveChangInsightsState,
        selectRetrieveInitiativeState,
      ].every((select) => select(state).success);

      return {
        retrieveSuccess,
        initiative,
        project: selectProject(projectId),
        changeInsightSettings: selectChangeInsightSettings(
          initiative ? initiative.surveyId : null
        )(state),
        surveyResponses: selectSurveyResponsesResults(state),
      };
    }
  )(state);

const ChangeInsightAnswersRespondentContainer = ({
  retrieveSuccess,
  surveyId,
  responseId,
  initiative,
  changeInsightSettings,
  surveyResponses,
  retrieveInitiative,
  retrieveChangeInsightDetails,
  disabled,
  slug,
}) => {
  const [respondentAnswers, setRespondentAnswers] = useState(null);

  useEffect(() => {
    if (!changeInsightSettings) {
      retrieveChangeInsightDetails(surveyId);
    }
    if (!initiative) {
      retrieveInitiative();
    }
  }, []);

  useEffect(() => {
    if (surveyResponses) {
      const response = surveyResponses.find((res) => res.id === +responseId);
      setRespondentAnswers(response);
    }
  }, [surveyResponses]);

  if (!retrieveSuccess) return <Empty simplified content={loadingContent} />;

  return (
    <React.Fragment>
      {initiative ? (
        <ChangeInsightRespondentAnswersHeader
          slug={slug}
          initiative={initiative}
          respondentAnswers={respondentAnswers}
        />
      ) : null}
      {respondentAnswers ? (
        <SubHeader>
          <h2 className="m-b-24">
            Feedback Form Response: {respondentAnswers.responderName}
          </h2>
          <div className="flex">
            <div className="flex header-item">
              <strong className="text-muted m-r-12">Status: </strong>
              <strong>
                Completed:{' '}
                <CompletionDate
                  completedAt={respondentAnswers.createdAt}
                  endDate={changeInsightSettings.endDate}
                />
              </strong>
            </div>
            <VerticalSeparator />
            <div className="flex header-item">
              <strong className="text-muted m-r-12 m-l-8">Date: </strong>
              <strong>
                {moment
                  .utc(respondentAnswers.createdAt)
                  .utcOffset('-07:00')
                  .format('MM/DD/YYYY')}
              </strong>
            </div>
          </div>
        </SubHeader>
      ) : null}

      {initiative ? (
        <ChangeInsightsRespondentHeader
          slug={slug}
          initiative={initiative}
          survey={changeInsightSettings}
          surveyResponses={surveyResponses}
        />
      ) : null}
      {respondentAnswers ? (
        <SurveyRespondentAnswersForm
          respondentAnswers={{
            ...respondentAnswers,
            surveyResult:
              typeof respondentAnswers.surveyResult === 'string'
                ? JSON.parse(respondentAnswers.surveyResult)
                : respondentAnswers.surveyResult,
          }}
          survey={{
            ...changeInsightSettings,
            surveyJson: formatedTemplate(changeInsightSettings),
          }}
          disabled={disabled}
        />
      ) : null}
    </React.Fragment>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeInsightAnswersRespondentContainer);
